import { Component, OnInit } from '@angular/core';
import {CashbackGroup} from '../../../../dto/cashbackGroup';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {CashbackGroupsService} from '../../../../cashback-groups.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-cashback-groups-edit',
  templateUrl: './cashback-groups-edit.component.html',
  styleUrls: ['./cashback-groups-edit.component.css']
})
export class CashbackGroupsEditComponent implements OnInit {

  cashbackGroup: CashbackGroup;
  cashbackGroupForm: FormGroup;

  constructor(private route: ActivatedRoute,
              private cashbackGroupsService: CashbackGroupsService,
              private formBuilder: FormBuilder,
              private location: Location
  ) { }
  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id == null) {
      this.initForm({} as CashbackGroup);
    } else {
      this.cashbackGroupsService.get(parseInt(id)).subscribe(result => {
        this.cashbackGroup = result;
        this.initForm(result);
      });
    }

  }

  initForm(cashbackGroup: CashbackGroup) {
    this.cashbackGroupForm = this.formBuilder.group({
      id: cashbackGroup.id,
      code: cashbackGroup.code,
      name: cashbackGroup.name,


      cashbackFactor: cashbackGroup.cashbackFactor,
      maxCashbackPerMonth: cashbackGroup.maxCashbackPerMonth,
      maxCashbackPerTransaction: cashbackGroup.maxCashbackPerTransaction,
      isEnabled: cashbackGroup.isEnabled,
      activeFrom: cashbackGroup.activeFrom,
      activeUntil: cashbackGroup.activeUntil,
      filterMerchantIds: cashbackGroup.filterMerchantIds,
      filterMccCodes: cashbackGroup.filterMccCodes,


    });
  }

  returnBack() {
    this.location.back();
  }

  onSubmit(form: FormGroup) {
    if (form.value.id) {
      this.cashbackGroupsService.update(form.value.id, form.value)
        .subscribe(() => this.returnBack());
    } else {
      this.cashbackGroupsService.add(form.value)
        .subscribe(() => this.returnBack());
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
}
